interface Props {
  value: number; // 0..100
  color?: string;
  height?: number;
  className?: string;
}

export function ProgressBar({
  value,
  color = "#E8613C",
  height = 8,
  className = "",
}: Props) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      className={`w-full bg-bg border border-border rounded-full overflow-hidden ${className}`}
      style={{ height }}
    >
      <div
        className="h-full rounded-full transition-[width] duration-500 ease-out"
        style={{ width: `${clamped}%`, backgroundColor: color }}
      />
    </div>
  );
}
